import procreate101 from './procreate101'
import procreate201 from './procreate201'
import procreate301 from './procreate301'
import procreate401 from './procreate401'
import GouacheBotanicals from './GouacheBotanicals'
import BeautifulLettering from './beautifulLettering'
import MessyWatercolors from './messyWatercolors'
import FlatFlorals from './flatFlorals'
import FlatFloralsDF from './flatl-florals-df'
import ProcreatePatterns from './procreatePatternsData'
import ProcreatePatternsDf from './procreatePatternsData-df'
import BirdsBlooms from './birds-blooms-data'
import StationeryDesign from './stationery-design-data'
import MixedMedia from './mixed-media-data'
import { ICourse, ICourse2 } from '@et/types/Courses'

export enum courseKeys {
  Procreate101 = 'procreate-for-beginners',
  Procreate201 = '3d-lettering-in-procreate',
  Procreate301 = 'watercolor-lettering-in-procreate',
  Procreate401 = 'watercolor-florals-in-procreate',
  GouacheBotanicals = 'gouache-botanicals-in-procreate',
  BeautifulLettering = 'beautiful-lettering',
  MessyWatercolors = 'messy-watercolors',
  FlatFloralsDF = 'ff-df',
  FlatFlorals = 'flat-florals',
  ProcreatePatterns = 'procreate-patterns',
  ProcreatePatternsDF = 'procreate-patterns-df',
  BirdsBlooms = 'fantasy-birds-blooms',
  StationeryDesign = 'staionery-design-in-procreate',
  MixedMedia = 'mixed-media-procreate'
}

export const courseModules: { [id: string]: ICourse } = {}

export const courseModulesV2: { [id: string]: ICourse2 } = {
  [courseKeys.Procreate101]: {
    ...procreate101,
  },
  [courseKeys.Procreate201]: {
    ...procreate201,
  },
  [courseKeys.Procreate301]: {
    ...procreate301,
  },
  [courseKeys.Procreate401]: {
    ...procreate401,
  },
  [courseKeys.GouacheBotanicals]: {
    ...GouacheBotanicals,
  },
  [courseKeys.BeautifulLettering]: {
    ...BeautifulLettering,
  },
  [courseKeys.MessyWatercolors]: {
    ...MessyWatercolors,
  },
  [courseKeys.FlatFlorals]: {
    ...FlatFlorals,
  },
  [courseKeys.FlatFloralsDF]: {
    ...FlatFloralsDF,
  },
  [courseKeys.ProcreatePatterns]: {
    ...ProcreatePatterns,
  },
  [courseKeys.ProcreatePatternsDF]: {
    ...ProcreatePatternsDf,
  },
  [courseKeys.BirdsBlooms]: {
    ...BirdsBlooms,
  },
  [courseKeys.StationeryDesign]: {
    ...StationeryDesign,
  },
  [courseKeys.MixedMedia]: {
    ...MixedMedia,
  }
}
